module.exports = __webpack_public_path__ + "media/icons/icon_document-47c818fc.png";